import { Link, useParams } from 'react-router'
import { getPreferredServicePath, serviceCategories, servicePages } from '../data'
import { NotFoundPage } from './NotFoundPage'

export function ServiceCategoryPage() {
  const { categorySlug } = useParams()
  const category = serviceCategories.find(({ slug }) => slug === categorySlug)

  if (!category) return <NotFoundPage />

  const categoryServices = servicePages.filter(
    ({ categoryId, enabled }) => enabled && categoryId === category.id,
  )

  return (
    <section className="section shell page-section">
      <div className="section-heading section-heading--wide">
        <p className="eyebrow">{category.eyebrow}</p>
        <h1>{category.name}</h1>
        <p>{category.summary}</p>
      </div>
      <div className="card-grid">
        {categoryServices.map((service) => (
          <article className="service-card" key={service.id}>
            <h2>{service.name}</h2>
            <p>{service.shortDescription}</p>
            <Link to={getPreferredServicePath(
              service.id,
              `/services/${category.slug}/${service.slug}`,
            )}>
              View service <span aria-hidden="true">→</span>
            </Link>
          </article>
        ))}
      </div>
    </section>
  )
}
